module.exports = __webpack_public_path__ + "static/img/13.e4e0a32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/eng/13.png
// module id = 0yUS
// module chunks = 0